import { render, staticRenderFns } from "./deviceBaiMaDetails.vue?vue&type=template&id=1f6936bd&scoped=true"
import script from "./deviceBaiMaDetails.vue?vue&type=script&lang=js"
export * from "./deviceBaiMaDetails.vue?vue&type=script&lang=js"
import style0 from "./deviceBaiMaDetails.vue?vue&type=style&index=0&id=1f6936bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6936bd",
  null
  
)

export default component.exports